module.exports = __webpack_public_path__ + "img/hussite_flag.61ca7ba0.png";